import { Gender } from '@pflegia/types/common/enums/gender.enum';

export {
  /** @deprecated Import from @pflegia/types/common instead. */
  Gender,
};

export const GENDER_TRANSLATIONS = {
  [Gender.Female]: 'Weiblich',
  [Gender.Male]: 'Männlich',
  [Gender.NonBinary]: 'Divers',
};
